(() => {
  function imageKey(source) {
    if (!source) return '';
    try {
      return decodeURIComponent(new URL(source, location.href).pathname.split('/').pop());
    } catch { return ''; }
  }

  async function updateFeatured(section) {
    if (section.dataset.lbFeaturedLoaded) return;
    section.dataset.lbFeaturedLoaded = 'pending';
    const currentGrid = section.querySelector('[data-lb-auto-products]');
    if (!currentGrid) return;
    const reservedImages = new Set();
    const reservedHandles = new Set();
    document.querySelectorAll('main img').forEach(image => {
      if (section.contains(image)) return;
      [image.currentSrc, image.getAttribute('src'), image.getAttribute('data-src')].forEach(source => {
        const key = imageKey(source);
        if (key) reservedImages.add(key);
      });
    });
    document.querySelectorAll('main a[href*="/products/"]').forEach(link => {
      if (section.contains(link)) return;
      const match = new URL(link.href, location.href).pathname.match(/\/products\/([^/]+)/);
      if (match) reservedHandles.add(decodeURIComponent(match[1]));
    });
    const allowed = card => !reservedHandles.has(card.dataset.featuredHandle) &&
      !(card.dataset.featuredImages || '').split('|').filter(Boolean).some(key => reservedImages.has(key));
    // Keep the initial feed safe even if the catalogue request fails.
    currentGrid.querySelectorAll('[data-featured-product]').forEach(card => {
      if (!allowed(card)) card.remove();
    });
    try {
      const response = await fetch(section.dataset.lbFeaturedUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Featured feed unavailable');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const candidates = documentFragment.querySelector('[data-lb-featured-candidates]');
      if (!candidates) throw new Error('Incomplete featured feed');
      let cards = [];
      const usedProducts = new Set();
      const usedGroups = new Set();
      for (const template of candidates.querySelectorAll('[data-lb-pair]')) {
        const pair = [...template.content.querySelectorAll('[data-featured-product]')];
        if (pair.length !== 2 || usedGroups.has(template.dataset.lbGroup) ||
            pair.some(card => !allowed(card) || usedProducts.has(card.dataset.featuredProduct))) continue;
        cards.push(...pair);
        pair.forEach(card => usedProducts.add(card.dataset.featuredProduct));
        usedGroups.add(template.dataset.lbGroup);
        if (cards.length === 4) break;
      }
      const matchingSets = cards.length === 4;
      if (!matchingSets) {
        cards = [];
        usedProducts.clear();
        for (const template of candidates.querySelectorAll('[data-lb-single]')) {
          const card = template.content.querySelector('[data-featured-product]');
          if (!card || !allowed(card) || usedProducts.has(card.dataset.featuredProduct)) continue;
          cards.push(card);
          usedProducts.add(card.dataset.featuredProduct);
          if (cards.length === 4) break;
        }
      }
      if (!cards.length) throw new Error('No distinct featured products');
      const grid = document.createElement('div');
      grid.className = currentGrid.className;
      grid.dataset.lbAutoProducts = '';
      grid.dataset.selection = matchingSets ? 'matching-sets' : 'newest-products';
      cards.forEach(card => grid.append(card.cloneNode(true)));
      currentGrid.replaceWith(grid);
      section.dataset.lbFeaturedLoaded = 'complete';
    } catch {
      section.dataset.lbFeaturedLoaded = 'fallback';
    }
  }
  function initialize() {
    document.querySelectorAll('[data-lb-featured-url]').forEach(updateFeatured);
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
